import {I18nFallbackLocale, LangOverrides, Translations} from '@/global/types/i18n';
import {VueI18nInstance} from 'vue-i18n';

export function getTranslations(source: LangOverrides, i18n: VueI18nInstance): Translations | string {

    const locale: string = i18n.locale;
    const fallbackLocale: I18nFallbackLocale = i18n.fallbackLocale as unknown as I18nFallbackLocale;

    if (source.lang_overrides) {
        const fallback: string[] = [locale]

        if (fallbackLocale[locale]) {
            fallback.push(...fallbackLocale[locale])
        }

        for (let i: number = 0; i < fallback.length; i++) {
            if (source.lang_overrides[fallback[i]]) {
                return source.lang_overrides[fallback[i]]
            }
        }
    }

    return {}
}

export function getTranslationValue(source: LangOverrides, property: string | string[], i18n: VueI18nInstance): string {

    const translations: Translations | string = getTranslations(source, i18n);
    const keys = "string" === typeof property ? [property] : property;

    if ("string" === typeof translations) {

        // source object is something like {[key]: String, lang_overrides: {[lang]: String}}
        return translations;
    }

    // Look for translated value
    const translation: undefined | null | string = keys.reduce(
        (result: null | string, key: string) => result
            ? result
            : (translations[key] ? translations[key] : result),
        null
    );

    // Get default value (not translated)
    return translation
        ? translation as string
        : keys.reduce(
            (result: string, key: string) => result
                ? result
                : (source[key] ? source[key] : result),
            ''
        )
}